"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/web.dom.iterable");
var _StepLayout = _interopRequireDefault(require("./StepLayout.vue"));
var _myform = _interopRequireDefault(require("@/mixins/myform"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * info:
 * step2 销售情况 page
 */
/** components */
/** mixins */
var _default2 = exports.default = {
  components: {
    StepLayout: _StepLayout.default
  },
  mixins: [_myform.default],
  props: {
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // 门店详情信息，仅用于展示不需要编辑的字段
    info: {
      type: Object,
      default: function _default() {
        return {
          storeInfo: {}
        };
      }
    },
    // 表单信息，所有步骤用一个表单
    form: {
      type: Object,
      default: function _default() {
        return {
          storeInfo: {}
        };
      }
    },
    // 表单规则
    rules: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 当前页面用到的 所有下拉options配置
    /**
     * optConfig.tireSupplierOptions: [], // 主要进货渠道select
     * optConfig.accountMethodOptions: [], // 结算方式select
     * optConfig.tyreBrandOptions: [], // 轮胎品牌select
     */
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isBailianFlag: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hasErrorTable: false // 百炼的需要任意填写一项
    };
  },
  computed: {
    monthlyStatistic: function monthlyStatistic() {
      var _ref = this.form.storeInfo || {},
        tireSalesInfos = _ref.tireSalesInfos;
      var arr = tireSalesInfos || [];
      var num = 0;
      arr.forEach(function (item) {
        var monthlyAvgSales = Number(item.monthlyAvgSales);
        if (monthlyAvgSales) {
          num += monthlyAvgSales;
        }
      });
      return num;
    },
    stockStatistic: function stockStatistic() {
      var _ref2 = this.form.storeInfo || {},
        tireSalesInfos = _ref2.tireSalesInfos;
      var arr = tireSalesInfos || [];
      var num = 0;
      arr.forEach(function (item) {
        var stock = Number(item.stock);
        if (stock) {
          num += stock;
        }
      });
      return num;
    }
  },
  methods: {
    updateFormValue: function updateFormValue(v, key, row) {
      row[key] = v;
      // 百炼的校验
      if (this.isBailianFlag) {
        if (this.itemHasVal(v)) {
          this.hasErrorTable = false;
        } else {
          var valid = this.validBailianTable();
          if (!valid) {
            this.hasErrorTable = true;
          } else {
            this.hasErrorTable = false;
          }
        }
      }
    },
    /** 销售table */tableIndex: function tableIndex(index) {
      return index + 1;
    },
    // 保存草稿
    onSaveDraft: function onSaveDraft() {
      console.log('保存草稿');
      this.$emit('draft');
    },
    // 保存并下一步
    onDraftAndGo: function onDraftAndGo() {
      var _this = this;
      console.log('保存并下一步');
      this.$refs['dataForm'].clearValidate();
      this.$refs['dataForm'].validate(function (valid) {
        if (!valid) {
          _this.$message.error(_this.$t('errorValid.formError'));
          return false;
        }
        // 继续校验百炼时，table必须任意填写一个
        if (_this.isBailianFlag && !_this.validBailianTable()) {
          _this.hasErrorTable = true;
          return false;
        }
        _this.hasErrorTable = false;
        console.log('校验通过');
        _this.$emit('draftAndGo');
      });
    },
    itemHasVal: function itemHasVal(v) {
      return v != null && v !== '';
    },
    validBailianTable: function validBailianTable() {
      var _this2 = this;
      // table里全是空的校验不通过
      return this.form.storeInfo.tireSalesInfos.some(function (item) {
        return _this2.itemHasVal(item.tireSupplier) || _this2.itemHasVal(item.paymentTerms) || _this2.itemHasVal(item.monthlyAvgSales) || _this2.itemHasVal(item.stock);
      });
    },
    // 下一步
    onNext: function onNext() {
      console.log('下一步');
      this.$emit('next');
    }
  }
};